module.exports = __webpack_public_path__ + "media/images/icon-close-913d997bab180cb52aeec098f715d4f4.svg";